import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-question-option-modal',
  templateUrl: './manage-question-option-modal.component.html',
  styleUrls: ['./manage-question-option-modal.component.scss']
})
export class ManageQuestionOptionModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
